/**
 * Custom JS for Horizon Theme (Neev)
 * Replaces custom.js and custom2.js from the original Prestige theme.
 * Vanilla JavaScript only — no jQuery dependency.
 * Loaded with `defer`.
 */

/* ==========================================================================
   1. Estimated Delivery Date Calculator (Cart pages fallback)
   ========================================================================== */

/**
 * On product pages, sf-delivery-date.liquid handles the calculation and
 * exposes window.__calculateETD and window.__deliveryDateFormatted.
 *
 * This fallback ensures .cartETD elements on cart/drawer pages still
 * get populated even when the block isn't present.
 */
(function () {
  /* If the block already ran (product page), just update any remaining .cartETD */
  if (window.__deliveryDateFormatted) {
    document.querySelectorAll('.cartETD').forEach(function (el) {
      el.textContent = window.__deliveryDateFormatted;
    });
    return;
  }

  /* Fallback: calculate with default 12 business days, no holidays */
  function calculateETD(businessDays) {
    var endDate = new Date();
    var count = 0;
    while (count < businessDays) {
      endDate.setDate(endDate.getDate() + 1);
      var day = endDate.getDay();
      if (day !== 0 && day !== 6) {
        count++;
      }
    }
    return endDate;
  }

  var etd = calculateETD(12);
  var formatted =
    etd.getDate() + ' ' + etd.toLocaleString('default', { month: 'short' });

  document.querySelectorAll('.cartETD').forEach(function (el) {
    el.textContent = formatted;
  });

  window.__calculateETD = calculateETD;
  window.__deliveryDateFormatted = formatted;
})();

/* ==========================================================================
   2. Sticky Bottom Bar — Scroll Activation + Customize Button
   ========================================================================== */

/**
 * Shows/hides the .stickbottom bar based on scroll position.
 * Mobile (<1009px): Always visible.
 * Desktop (>1008px): Always visible (static ATC is hidden, sticky replaces it).
 * Customize button scrolls to Hulk options and pulses them.
 */
(function () {
  var bar = document.querySelector('.stickbottom');
  if (!bar) return;

  var ticking = false;

  /* Show sticky bar immediately on all viewports */
  bar.classList.add('activated');

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(function () {
      /* Keep bar activated on scroll (defensive — ensures it stays visible) */
      bar.classList.add('activated');
      ticking = false;
    });
  });

  /* Scroll to top on Add to Cart click */
  var atcBtn = bar.querySelector('.stickbottom__addtocart');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      setTimeout(function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300);
    });
  }

  /* Customize button — scroll to Hulk options + highlight animation */
  var customizeBtn = bar.querySelector('[data-scroll-to-options]');
  if (customizeBtn) {
    customizeBtn.addEventListener('click', function () {
      /* Try multiple selectors for Hulk options container */
      var target =
        document.querySelector('.fabric-button-container') ||
        document.querySelector('[id^="hulkapps_option_list_"]') ||
        document.querySelector('[id^="hulkapps_custom_options_"]') ||
        document.querySelector('.sf-hulk-options');

      if (target) {
        var top = target.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      /* Delay highlight until scroll animation completes (~700ms) */
      setTimeout(function () {
        document.querySelectorAll('[id^="hulkapps_option_list_"]').forEach(function (el) {
          el.classList.remove('enim');
          void el.offsetWidth; /* Force reflow to restart animation */
          el.classList.add('enim');
        });
        document.querySelectorAll('.customize').forEach(function (el) {
          el.classList.remove('enim');
          void el.offsetWidth;
          el.classList.add('enim');
        });
      }, 700);

      /* Cleanup after animation completes (700ms delay + 2500ms animation) */
      setTimeout(function () {
        document.querySelectorAll('[id^="hulkapps_option_list_"]').forEach(function (el) {
          el.classList.remove('enim');
        });
        document.querySelectorAll('.customize').forEach(function (el) {
          el.classList.remove('enim');
        });
      }, 3200);
    });
  }

  /* Mobile only: hide Customize button when Hulk options section is fully visible in viewport.
     On desktop (>=750px), Customize always shows — no observer needed. */
  var observerSetUp = false;
  function setupCustomizeObserver() {
    if (observerSetUp) return;
    /* Only apply on mobile — desktop always shows both buttons */
    if (window.innerWidth >= 750) return;

    var hulkTarget =
      document.querySelector('[id^="hulkapps_custom_options_"]') ||
      document.querySelector('.fabric-button-container') ||
      document.querySelector('[id^="hulkapps_option_list_"]') ||
      document.querySelector('.sf-hulk-options');
    if (!hulkTarget) return;

    observerSetUp = true;
    /* threshold: 0.15 — hide Customize as soon as 15% of the Hulk section is visible.
       rootMargin bottom: -80px accounts for the sticky bar covering the bottom. */
    var hulkObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= 0.15) {
          bar.classList.add('activated2');
        } else {
          bar.classList.remove('activated2');
        }
      });
    }, { threshold: [0, 0.15], rootMargin: '0px 0px -80px 0px' });
    hulkObserver.observe(hulkTarget);
  }

  /* Hulk options may load late (third-party app), so retry observer setup */
  [1000, 3000, 6000, 10000].forEach(function (delay) {
    setTimeout(setupCustomizeObserver, delay);
  });
})();

/* ==========================================================================
   Product page: hide buy-buttons-block (sticky bar replaces them)
   ========================================================================== */
(function () {
  var tpl = document.body.getAttribute('data-template') || '';
  if (tpl.indexOf('product') !== 0) return;

  /* Hide static buy-buttons-block via JS as a belt-and-suspenders fallback */
  document.querySelectorAll('.buy-buttons-block').forEach(function (el) {
    el.style.setProperty('display', 'none', 'important');
  });
})();

/* ==========================================================================
   3. Collection Description Toggle (Read More / Read Less)
   ========================================================================== */

/**
 * Delegated click handler that toggles the collection description between
 * a truncated preview and the full content.
 *
 * Markup expectations:
 *   <div class="collection-description-content collection-description--truncated">
 *     ...long text...
 *   </div>
 *   <button class="vm-collect">read more</button>
 */
document.addEventListener('click', function (e) {
  if (!e.target.matches('.vm-collect')) return;

  var desc = document.querySelector('.collection-description-content');
  if (!desc) return;

  desc.classList.toggle('collection-description--expanded');

  var isExpanded = desc.classList.contains('collection-description--expanded');
  e.target.textContent = isExpanded ? 'read less' : 'read more';
});

/* ==========================================================================
   3. Copy to Clipboard
   ========================================================================== */

/**
 * Copy the text content of a DOM element (selected by CSS selector) to
 * the system clipboard.
 *
 * Uses the modern navigator.clipboard API when available, with a
 * textarea-based fallback for older browsers.
 *
 * @param {string} selector - CSS selector for the element whose text to copy.
 */
function copyToClipboard(selector) {
  var el =
    typeof selector === 'string'
      ? document.querySelector(selector)
      : selector;
  if (!el) return;

  var text = el.textContent.trim();

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).catch(function () {
      // Fallback on clipboard API failure (e.g. permissions).
      fallbackCopy(text);
    });
  } else {
    fallbackCopy(text);
  }
}

/**
 * Fallback clipboard copy using a temporary textarea and execCommand.
 * @param {string} text
 */
function fallbackCopy(text) {
  var textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand('copy');
  } catch (_) {
    // Silently fail.
  }
  document.body.removeChild(textarea);
}

/**
 * Show "Copied!" visual feedback on <copy> elements when clicked.
 */
document.addEventListener('click', function (e) {
  var copyEl = e.target.closest('copy');
  if (!copyEl) return;

  copyEl.classList.add('active');
  setTimeout(function () {
    copyEl.classList.remove('active');
  }, 2000);
});

/* ==========================================================================
   4. External Links — Open in New Tab
   ========================================================================== */

/**
 * Automatically sets target="_blank" and rel="noreferrer noopener" on all
 * anchor elements that point to external domains.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href]').forEach(function (link) {
    if (link.hostname && link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  });
});

/* ==========================================================================
   5. Back-to-Top Button
   ========================================================================== */

/**
 * Shows / hides a ".back-to-top" button based on scroll position.
 * Becomes visible once the user has scrolled past 600 px.
 * Clicking scrolls smoothly to the top.
 */
(function () {
  var btn = document.querySelector('.back-to-top');
  if (!btn) return;

  var ticking = false;

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;

    window.requestAnimationFrame(function () {
      btn.style.display = window.scrollY >= 600 ? 'flex' : 'none';
      ticking = false;
    });
  });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* ==========================================================================
   6. iOS Drawer Scroll Lock
   ========================================================================== */

/**
 * On iOS devices, locking body scroll when a drawer or dialog is open
 * prevents the background from rubber-banding. A MutationObserver watches
 * for open/close state changes on dialog and drawer elements used by the
 * Horizon theme's Web Component architecture.
 */
(function () {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (!isIOS) return;

  var scrollPos = 0;
  var isLocked = false;

  function lock() {
    if (isLocked) return;
    isLocked = true;
    scrollPos = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollPos + 'px';
    document.body.style.width = '100%';
  }

  function unlock() {
    if (!isLocked) return;
    isLocked = false;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPos);
  }

  // Watch for Horizon dialog/drawer open/close via the `open` attribute
  // on <dialog> elements and `aria-hidden` changes on drawer components.
  var observer = new MutationObserver(function () {
    var anyOpen = document.querySelector(
      'dialog[open], [aria-hidden="false"].drawer'
    );
    if (anyOpen) {
      lock();
    } else {
      unlock();
    }
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'aria-hidden'],
  });
})();

/* ==========================================================================
   7. Hulk Discount Button Handler
   ========================================================================== */

/**
 * When the Hulk Apps discount button is clicked, poll for the discounted
 * price element and update the cart total display. Works in both the
 * drawer cart and the full cart page contexts.
 */
document.addEventListener('click', function (e) {
  // Apply discount
  if (e.target.matches('.hulkapps_discount_button')) {
    var interval = setInterval(function () {
      var discountEl = document.querySelector('.after_discount_price .money');
      if (discountEl) {
        var total = discountEl.textContent;
        var checkoutTotal = document.querySelector('.hulkcode-total');
        if (checkoutTotal) checkoutTotal.innerHTML = total;
        clearInterval(interval);
      }
    }, 50);

    // Safety net: stop polling after 5 seconds.
    setTimeout(function () {
      clearInterval(interval);
    }, 5000);
  }

  // Remove discount
  if (e.target.matches('.discount_code_box .close-tag')) {
    var el = document.querySelector('.hulkcode-total');
    if (el) el.innerHTML = '';
  }
});

/* ==========================================================================
   8. ReelUp Slide Data Handler
   ========================================================================== */

/**
 * Listens for the custom `ReelUpSlideDataLoaded` event and wires up
 * product-page navigation on mobile mini-detail slides.
 */
document.addEventListener('ReelUpSlideDataLoaded', function (e) {
  var selector = e.detail && e.detail.Selector;
  if (!selector) return;

  var wrapper = selector.closest('.reelUp_popup_container');
  if (!wrapper) return;

  var mobileDetails = wrapper.querySelector(
    '.reelUp_mini_details.mini_show'
  );
  if (!mobileDetails) return;

  mobileDetails
    .querySelectorAll('.reelUp_mini_details_bottom')
    .forEach(function (slide) {
      slide.addEventListener('click', function (ev) {
        ev.preventDefault();
        var bottom = ev.target.closest('.reelUp_mini_details_bottom');
        var handle = bottom ? bottom.getAttribute('data-product-handle') : null;
        if (handle) {
          window.open('/products/' + handle, '_self');
        }
      });
    });
});

/* ==========================================================================
   9. Custom Modal Handler
   ========================================================================== */

/**
 * Generic modal open/close via delegated click events.
 *
 * Open:  click on `.modal-toggle` or `[data-modal-open]`
 *        (uses `data-modal-open` value as the modal ID, defaults to "ramd").
 * Close: click on `.custom-modal .close` or `.custom-modal__overlay`.
 *
 * Body scroll is locked while a modal is visible.
 */
document.addEventListener('click', function (e) {
  // Open modal
  var openTrigger = e.target.closest('.modal-toggle, [data-modal-open]');
  if (openTrigger) {
    var modalId = openTrigger.getAttribute('data-modal-open') || 'ramd';
    var modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    return;
  }

  // Close modal
  var closeTrigger = e.target.closest(
    '.custom-modal .close, .custom-modal__overlay'
  );
  if (closeTrigger) {
    var modalEl = closeTrigger.closest('.custom-modal') || closeTrigger;
    // If the overlay itself is the modal wrapper
    if (
      closeTrigger.classList.contains('custom-modal__overlay') &&
      !modalEl.classList.contains('custom-modal')
    ) {
      modalEl = closeTrigger.closest('.modalin') || closeTrigger.parentElement;
    }
    if (modalEl) {
      modalEl.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }
});

/**
 * Also handle `.modalin` visibility toggling. The `.modalin` class is used
 * in some legacy markup patterns.
 */
document.addEventListener('click', function (e) {
  // Toggle .modalin open
  var modalInTrigger = e.target.closest('[data-modalin-toggle]');
  if (modalInTrigger) {
    var targetId = modalInTrigger.getAttribute('data-modalin-toggle');
    var modalIn = document.getElementById(targetId);
    if (modalIn) {
      modalIn.classList.toggle('is-visible');
      document.body.style.overflow = modalIn.classList.contains('is-visible')
        ? 'hidden'
        : '';
    }
    return;
  }

  // Close .modalin on backdrop (self) click
  if (e.target.classList.contains('modalin')) {
    e.target.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  // Close .modalin on overlay click
  if (e.target.matches('.modalin__overlay')) {
    var parent = e.target.closest('.modalin');
    if (parent) {
      parent.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  // Close .modalin on close button click
  var closeBtn = e.target.closest('.modalin .modalin__close');
  if (closeBtn) {
    var parentModal = closeBtn.closest('.modalin');
    if (parentModal) {
      parentModal.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }
});

/* ==========================================================================
   10. Size Chart Modal
   ========================================================================== */

/**
 * Size Chart modal with:
 *   - Tab switching between "Size Chart" and "How to Measure" panes.
 *   - Inches / CM unit toggle.
 *   - Open / close behaviour.
 *
 * Markup expectations:
 *   <div class="size-chart-modal" id="size-chart-modal">
 *     <div class="size-chart-modal__overlay"></div>
 *     <div class="size-chart-modal__content">
 *       <button class="size-chart-modal__close">&times;</button>
 *       <div class="size-chart-modal__tabs">
 *         <button class="size-chart-tab" data-tab="chart">Size Chart</button>
 *         <button class="size-chart-tab" data-tab="measure">How to Measure</button>
 *       </div>
 *       <div class="size-chart-panel" data-panel="chart"> ... </div>
 *       <div class="size-chart-panel" data-panel="measure"> ... </div>
 *       <div class="size-chart-units">
 *         <button class="size-chart-unit" data-unit="in">Inches</button>
 *         <button class="size-chart-unit" data-unit="cm">CM</button>
 *       </div>
 *     </div>
 *   </div>
 */
(function () {
  /**
   * Open the size chart modal.
   */
  function openSizeChart() {
    var modal = document.getElementById('size-chart-modal');
    if (!modal) return;
    modal.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  /**
   * Close the size chart modal.
   */
  function closeSizeChart() {
    var modal = document.getElementById('size-chart-modal');
    if (!modal) return;
    modal.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  /**
   * Switch the active tab and show the corresponding panel.
   * @param {string} tabName - The `data-tab` / `data-panel` value to activate.
   */
  function switchTab(tabName) {
    var modal = document.getElementById('size-chart-modal');
    if (!modal) return;

    // Update tab buttons
    modal.querySelectorAll('.size-chart-tab').forEach(function (tab) {
      if (tab.getAttribute('data-tab') === tabName) {
        tab.classList.add('is-active');
      } else {
        tab.classList.remove('is-active');
      }
    });

    // Update panels
    modal.querySelectorAll('.size-chart-panel').forEach(function (panel) {
      if (panel.getAttribute('data-panel') === tabName) {
        panel.classList.add('is-active');
        panel.removeAttribute('hidden');
      } else {
        panel.classList.remove('is-active');
        panel.setAttribute('hidden', '');
      }
    });
  }

  /**
   * Toggle between inches and centimetres.
   * @param {string} unit - "in" or "cm".
   */
  function switchUnit(unit) {
    var modal = document.getElementById('size-chart-modal');
    if (!modal) return;

    // Update unit toggle buttons
    modal.querySelectorAll('.size-chart-unit').forEach(function (btn) {
      if (btn.getAttribute('data-unit') === unit) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });

    // Show/hide the corresponding unit rows or columns
    modal.querySelectorAll('[data-unit-row]').forEach(function (row) {
      if (row.getAttribute('data-unit-row') === unit) {
        row.removeAttribute('hidden');
        row.style.display = '';
      } else {
        row.setAttribute('hidden', '');
        row.style.display = 'none';
      }
    });

    // Alternative: toggle class on the chart container
    var chartContainer = modal.querySelector('.size-chart-data');
    if (chartContainer) {
      chartContainer.setAttribute('data-active-unit', unit);
    }
  }

  // Delegated event listener for all size chart interactions.
  document.addEventListener('click', function (e) {
    // Open
    if (e.target.closest('.size-chart-open, [data-size-chart-open]')) {
      e.preventDefault();
      openSizeChart();
      return;
    }

    // Close (close button or overlay)
    if (
      e.target.closest('.size-chart-modal__close') ||
      e.target.matches('.size-chart-modal__overlay')
    ) {
      closeSizeChart();
      return;
    }

    // Tab switching
    var tab = e.target.closest('.size-chart-tab');
    if (tab) {
      var tabName = tab.getAttribute('data-tab');
      if (tabName) switchTab(tabName);
      return;
    }

    // Unit toggle
    var unitBtn = e.target.closest('.size-chart-unit');
    if (unitBtn) {
      var unit = unitBtn.getAttribute('data-unit');
      if (unit) switchUnit(unit);
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('size-chart-modal');
      if (modal && modal.classList.contains('is-visible')) {
        closeSizeChart();
      }
    }
  });

  // Expose globally so inline onclick handlers can use them if needed.
  window.openSizeChart = openSizeChart;
  window.closeSizeChart = closeSizeChart;
})();

/* ==========================================================================
   11. Delivery Date Display on Cart
   ========================================================================== */

/**
 * On DOMContentLoaded, calculate and display the estimated delivery date
 * inside the cart. Sample Sale products receive a 5-business-day estimate;
 * all other products receive 12 business days.
 *
 * Re-uses the __calculateETD helper exposed by section 1.
 */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.__calculateETD !== 'function') return;

  // Check each cart line item for Sample Sale tagging.
  var cartItems = document.querySelectorAll(
    '.cart-item, [data-cart-item], .cart-drawer__item'
  );

  cartItems.forEach(function (item) {
    var isSample = item.hasAttribute('data-sample-sale');
    var days = isSample ? 5 : 12;
    var etd = window.__calculateETD(days);
    var formatted =
      etd.getDate() +
      ' ' +
      etd.toLocaleString('default', { month: 'short' });

    var etdEl = item.querySelector('.cartETD');
    if (etdEl) {
      etdEl.textContent = formatted;
    }
  });

  // Also update any standalone .cartETD elements outside of cart items
  // (e.g. a global "Estimated delivery" line in the cart summary).
  var globalETD = document.querySelectorAll(
    '.cart-summary .cartETD, .cart-drawer__summary .cartETD'
  );
  if (globalETD.length) {
    var defaultDays = document.querySelector('[data-sample-sale]') ? 5 : 12;
    var etd = window.__calculateETD(defaultDays);
    var formatted =
      etd.getDate() +
      ' ' +
      etd.toLocaleString('default', { month: 'short' });

    globalETD.forEach(function (el) {
      el.textContent = formatted;
    });
  }
});

/* ==========================================================================
   12. Offer Accordion Toggle
   ========================================================================== */

/**
 * Simple accordion for offer sections. Toggles `aria-expanded` and
 * animates max-height on the content panel.
 */
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.offer-accordion__trigger');
  if (!trigger) return;

  var expanded = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', String(!expanded));

  var content = trigger.nextElementSibling;
  if (content) {
    content.hidden = expanded;
    content.style.maxHeight = expanded ? '0' : content.scrollHeight + 'px';
  }
});

/* ==========================================================================
   12. Featured Collections - Tab Toggle
   ========================================================================== */

/**
 * Handles Prestige-style [data-action="toggle-tab"] for featured-collections
 * section tab switching. Shows/hides TabPanels and updates active state.
 */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-action="toggle-tab"]');
  if (!btn) return;

  var section = btn.closest('[data-section-type="featured-collections"]');
  if (!section) return;

  // Deactivate all tabs
  var tabs = section.querySelectorAll('[data-action="toggle-tab"]');
  tabs.forEach(function (tab) {
    tab.classList.remove('is-active');
    tab.setAttribute('aria-selected', 'false');
  });

  // Activate clicked tab
  btn.classList.add('is-active');
  btn.setAttribute('aria-selected', 'true');

  // Hide all panels, show the target
  var targetId = btn.getAttribute('aria-controls');
  var panels = section.querySelectorAll('.TabPanel');
  panels.forEach(function (panel) {
    panel.setAttribute('aria-hidden', 'true');
  });

  var targetPanel = document.getElementById(targetId);
  if (targetPanel) {
    targetPanel.setAttribute('aria-hidden', 'false');
  }
});
